import React, { useState, useEffect } from "react";
import Header from "../../../components/Header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import { Box, Grid, TextField } from "@mui/material";
import "./mergePdf.scss";
import List from "@mui/material/List";
import CheckboxTitle from "../../../components/UploadBatchRecord/CheckboxTitle/CheckboxTitle";
import SelectedFileList from "../../../components/UploadBatchRecord/SelectedFileList/SelectedFileList";
import constants from "../../../constants/constantValues";
import BottomButtonsList from "../../../components/UploadBatchRecord/BottomButtonsList/BottomButtonsList";
import { useDispatch, useSelector } from "react-redux";
import {
  listBoxFiles,
  mergePdfFiles,
} from "../../../redux/administrator/actions";
import { useLocation, useNavigate } from "react-router-dom";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import HeaderButton from "../../../components/Controls/Buttons/HeaderButton";
import ProgressBar from "../../../components/ProgressBar";
import { adminRoutes } from "../../../routes/routeConstants";

const Index = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { GRANT, PREVIOUS } = constants;
  // const [selectedName, setSelectedButton] = useState("pdfs");
  const [selectedBottomButton, setBottomButtonName] = useState(PREVIOUS);
  const [checkedFiles, setCheckedFiles] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [fileName, setFileName] = useState("");
  const [loader, setLoader] = useState(false);
  const [message, setMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [severity, setSeverity] = useState("");
  // let propsData = props?.location?.state;
  // if (propsData?.value) {
  //   localStorage.setItem("pvalue", propsData.value);
  //   localStorage.setItem("folderName", propsData.folderName);
  // }
  let apiStatus = useSelector((state) => state?.admin?.apiStatus);
  let group = useSelector((state) => state?.admin?.boxFiles);
  const navigate = useNavigate();

  useEffect(() => {
    setGroupData(group);
  }, [group]);

  useEffect(() => {
    // let pdata = localStorage.getItem("pvalue");
    let pdata = location?.state?.sendData?.value;
    let data = {
      folderId: pdata,
      fileType: "pdfs",
      to_merge: true,
    };
    dispatch(listBoxFiles(data));
  }, [dispatch]);
  useEffect(() => {
    //Success and error notification
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus.loader === false) {
        setLoader(false);
        if (apiStatus.message !== null && apiStatus.next === true) {
          setMessage(apiStatus?.message);
          setSeverity("success");
          setIsOpen(true);
          setTimeout(() => {
          navigate(`/${adminRoutes.mergePdf}`)
          }, 2000);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiStatus]);

  const handleToggle = (value) => () => {
    const currentIndex = checkedFiles.indexOf(value);
    let newChecked = [...checkedFiles];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setCheckedFiles(newChecked);
  };

  const removeSelectedFile = (index) => {
    let addedFiles = [...checkedFiles];
    if (index > -1) {
      addedFiles.splice(index, 1);
      setCheckedFiles(addedFiles);
    }
  };

  const onSelectBottomButton = (selectedButton = "") => {
    setBottomButtonName(selectedButton);
    if (/[^a-zA-Z0-9_]/.test(fileName)) {
      setMessage("File Name cannot contain special character");
      setIsOpen(true);
      setSeverity("error");
    } else if (selectedButton === PREVIOUS) {
      navigate(`/${adminRoutes.mergePdf}`)
    } else if (selectedButton === GRANT) {
      let data = {
        body: {
          file_name: fileName,
          client_file_details: checkedFiles,
        },
      };
      if (fileName === "") {
        setIsOpen(true);
        setSeverity("error");
        setMessage("Please enter Pdf Name");
      }
      if (checkedFiles?.length > 1) {
        dispatch(mergePdfFiles(data));
        setLoader(true);
      } else {
        setIsOpen(true);
        setSeverity("error");
        setMessage("Please select atleast two file");
      }
    }
  };

  return (
    <>
      <Header page="new-project" />
      {loader ? <ProgressBar /> : ""}

      {isOpen ? (
        <CustomizedSnackbars
          className="popup"
          handleClose={() => setIsOpen(false)}
          severity={severity}
          state={isOpen}
          text={message}
        />
      ) : (
        <></>
      )}
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            <Box className="listPage-graybox"></Box>
            <Grid container className="merge-pdf-header">
              <Grid item md={5}>
                <HeaderButton
                  className={"header-btn"}
                  text={"pdf"}
                  cusStyle={{
                    margin: "0px 0px 0px 19px",
                    minWidth: "230px",
                    height: "30px",
                  }}
                ></HeaderButton>
              </Grid>
              <Grid item md={7}>
                <TextField
                  className="m-4"
                  size="small"
                  label="PDF Name"
                  onChange={(event) => setFileName(event.target.value)}
                ></TextField>
              </Grid>
            </Grid>
            <Grid container>
              <Grid className="scroll-wrapper" item xs={5}>
                <List className="scroller check-box-style">
                  {groupData?.map((value, index) => {
                    return (
                      <CheckboxTitle
                        key={index}
                        checked={checkedFiles}
                        onClick={(e) => handleToggle(e)}
                        value={value}
                      ></CheckboxTitle>
                    );
                  })}
                </List>
              </Grid>

              <Grid className="scroller .scroll-wrapper" item xs={7}>
                <Grid container className="scroller-container" spacing={1}>
                  {checkedFiles.map((value, index) => (
                    <Grid key={index} item xs={2} sm={5.8} md={5.8}>
                      <SelectedFileList
                        onClick={() => {
                          removeSelectedFile(index);
                        }}
                        value={value}
                      ></SelectedFileList>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                <BottomButtonsList
                  onClick={(e, action) => {
                    onSelectBottomButton(e, action);
                  }}
                  selectedKey={selectedBottomButton}
                  position="end"
                  headerColor="#FFFFF"
                  isNextDisable={
                    fileName !== "" && checkedFiles.length > 0 ? false : true
                  }
                  isPrevious={true}
                ></BottomButtonsList>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Index;
